import { CodeiumEditor } from '@codeium/react-code-editor'
import React, { useEffect, useRef } from 'react'
import { extensionToLanguage } from '../../utils/constants'
import './CodeEditor.css'

interface Props {
  source: string
  fileName: string
  handleChange: (text: string) => void
}

const CodeEditor: React.FC<Props> = (props) => {

  useEffect(() => {

  }, []);

  return (
    <div className='flex flex-1 flex-col'>
      <CodeiumEditor
        className='custom-editor h-full'
        value={props.source || 'Oops! Something went wrong...'}
        onChange={(value) => props.handleChange(value || props.source)}
        language={props.source ? extensionToLanguage[props.fileName.split('.').pop() || 'java'].toLowerCase() : ''}
        theme="vs-dark"
        height='100%'
      />
    </div>
  )
}

export default CodeEditor